// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function s(prim) {
  return prim;
}

function Comps(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "content",
                  id: "content"
                }, React.createElement("div", {
                      className: "tile is-ancestor"
                    }, React.createElement("div", {
                          className: "tile is-parent"
                        }, React.createElement("article", {
                              className: "tile is-child notification is-light"
                            }, React.createElement("p", {
                                  className: "title"
                                }, "Dive Stick"), React.createElement("p", {
                                  className: "subtitle"
                                }, "Comps scored with ", React.createElement("a", {
                                      href: "https://flaretiming.com"
                                    }, "Flare Timing"), " and presented with ", React.createElement("a", {
                                      href: "https://rescript-lang.org/"
                                    }, "rescript"))))), React.createElement("p", undefined, "Want", React.createElement("a", {
                          href: "https://flaretiming.com/posts/2018-12-19-add-a-comp.html"
                        }, " your comp here"), "?"), React.createElement("div", {
                      className: "tile is-ancestor"
                    }, React.createElement("div", {
                          className: "tile is-vertical is-5"
                        }, React.createElement("div", {
                              className: "tile"
                            }, React.createElement("div", {
                                  className: "tile is-parent is-vertical"
                                }, React.createElement("div", {
                                      className: "tile is-child box"
                                    }, React.createElement("h3", undefined, "Paragliding"), React.createElement("p", undefined), React.createElement("ul", undefined, React.createElement("li", undefined, "Italian Open ", React.createElement("a", {
                                                  href: "/comp-prefix/2020-italy-open"
                                                }, "2020")), React.createElement("li", undefined, "Dalmatian ", React.createElement("a", {
                                                  href: "/comp-prefix/2019-dalmatian"
                                                }, "2019"), " ", React.createElement("a", {
                                                  href: "/comp-prefix/2018-dalmatian"
                                                }, "2018")), React.createElement("ul", undefined, React.createElement("p", undefined)))), React.createElement("div", {
                                      className: "tile is-child box"
                                    }, React.createElement("h3", undefined, "Comp Archetypes"), React.createElement("p", undefined), React.createElement("ul", undefined, React.createElement("li", undefined, React.createElement("a", {
                                                  href: "/comp-prefix/1976-never-land"
                                                }, "1976 Never Land")), React.createElement("li", undefined, React.createElement("a", {
                                                  href: "/comp-prefix/1989-lift-lines"
                                                }, "1989 Lift Lines")), React.createElement("ul", undefined, React.createElement("p", undefined))))))), React.createElement("div", {
                          className: "tile is-vertical is-7"
                        }, React.createElement("div", {
                              className: "tile"
                            }, React.createElement("div", {
                                  className: "tile is-parent is-vertical"
                                }, React.createElement("div", {
                                      className: "tile is-child box"
                                    }, React.createElement("h3", undefined, "Hang Gliding"), React.createElement("h5", undefined, "Oceania"), React.createElement("ul", undefined, React.createElement("li", undefined, "Forbes Flatlands ", React.createElement("a", {
                                                  href: "/comp-prefix/2018-forbes"
                                                }, "2018"), " ", React.createElement("a", {
                                                  href: "/comp-prefix/2017-forbes"
                                                }, "2017"), " ", React.createElement("a", {
                                                  href: "/comp-prefix/2016-forbes"
                                                }, "2016"), " ", React.createElement("a", {
                                                  href: "/comp-prefix/2015-forbes"
                                                }, "2015"), " ", React.createElement("a", {
                                                  href: "/comp-prefix/2014-forbes"
                                                }, "2014"), " ", React.createElement("a", {
                                                  href: "/comp-prefix/2012-forbes"
                                                }, "2012")), React.createElement("li", undefined, "Dalby Big Air ", React.createElement("a", {
                                                  href: "/comp-prefix/2017-dalby"
                                                }, "2017"))), React.createElement("h5", undefined, "Europe"), React.createElement("ul", undefined, React.createElement("li", undefined, "Meduno ", React.createElement("a", {
                                                  href: "/comp-prefix/2020-meduno"
                                                }, "2020")), React.createElement("li", undefined, "Tolmezzo ", React.createElement("a", {
                                                  href: "/comp-prefix/2019-italy"
                                                }, "2019"))), React.createElement("h5", undefined, "Americas"), React.createElement("ul", undefined, React.createElement("li", undefined, "Green Swamp Klassic 2016 ", React.createElement("a", {
                                                  href: "/comp-prefix/2016-greenswamp"
                                                }, "Topless"), " ", React.createElement("a", {
                                                  href: "/comp-prefix/2016-greenswamp-sport"
                                                }, "Kingposted")), React.createElement("li", undefined, "Big Spring ", React.createElement("a", {
                                                  href: "2016-big-spring"
                                                }, "2016")), React.createElement("li", undefined, "QuestAir Open ", React.createElement("a", {
                                                  href: "/comp-prefix/2016-quest"
                                                }, "2016"))))))))));
}

var make = Comps;

export {
  s ,
  make ,
  
}
/* react Not a pure module */
